import { render } from "./expertsFeature.vue?vue&type=template&id=72548586"
import script from "./expertsFeature.vue?vue&type=script&lang=js"
export * from "./expertsFeature.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__